import { AppState } from '../models/state/appState';
import { SubmissionsState } from '../models/state/submissionsState';

/**
 * Selected the submission state.
 * @param state The aplication state.
 */
export function selectSubmission(state: AppState) {
  return state.submission;
}

/**
 * Selects the submissions state.
 * @param state The aplication state.
 */
export function selectSubmissions(state: AppState): SubmissionsState {
  return state.submissions;
}
